import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "map_pin",
  "use": "map_pin-usage",
  "viewBox": "0 0 456 548",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 456 548\" id=\"map_pin\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#6A9AE6\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"42\" opacity=\".09\" transform=\"translate(21 21)\"><path d=\"M414 207c0 161-207 299-207 299S0 368 0 207C0 92.677 92.677 0 207 0s207 92.677 207 207z\" /><circle cx=\"207\" cy=\"207\" r=\"69\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol